<template>
  <div>
    <div class="text-uppercase font-weight-medium grey--text text-left my-2">{{ title }}</div>
    <p v-if="description" class="description">{{ description }}</p>
    <ul v-for="point in points" :key="point.text">
      <li class="mt-2" v-if="point.url">
        {{ point.prefix }}
        <a :href="docs(point.url,point.id)" target="_blank">{{ point.text }}</a>
      </li>
      <li class="mt-2" v-else>{{ point }}</li>
    </ul>
    <ul v-if="documentation">
      <li class="mt-2">
        {{ $t('more') }}
        <a :href="docsUrl" target="_blank">{{ $t('here') }}</a>.
      </li>
    </ul>  
    <img v-if="screenshot" :src="screenshot" width="100%" />
  </div>
</template>

<script>
import { docsUrl } from '@/services/docs'

export default {
  props: {
    /**
     * The information section title.
     */
    title: String,
    /**
     * The information data, as a single description or as a list of points.
     */
    info: [ String, Object ],
    /**
     * Optional screenshot to be displayed after the description.
     */
    screenshot: String,
    /**
     * Optional documentation redirection to be displayed.
     */
    documentation: Object
  },
  methods: {
    docs (url, id) {
      return docsUrl(url, id)
    }
  },
  computed: {
    description () {
      return typeof this.info === 'string' && this.info
    },
    points () {
      return typeof this.info === 'object' && this.info
    },
    docsUrl () {
      return docsUrl(this.documentation.url, this.documentation.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "more": "For more information click",
    "here": "here"
  }
}
</i18n>
